const e=()=>{const e=process.env.REACT_APP_ENV;return e&&e!=="undefined"?["local","qa","dev","stg"].includes(e):true};export default e;